import styled from 'styled-components';

export const BreadcrumbsContainer = styled.div`
    padding: 10px 0;
`;

export const Container = styled.div` 
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    
`;
export const Back = styled.button` 
    width: 28px;
    height: 28px;
    border-radius: 100%;
    background: #fff;
    display: flex; 
    align-items: center;
    justify-content: center;
`;
